import { db } from "../services/firebase";
import { ref, push, set } from "firebase/database";

export default function useSaveContactMessage() {

    const saveContactMessage = async (data) => {
        try {
            const newRef = push(ref(db, "Others/ContactRequest"));

            await set(newRef, {
                ...data,
                submittedAt: Date.now()
            });

            console.log("✅ Contact message saved");

        } catch (error) {
            console.error("❌ Error saving contact message:", error);
            throw error;
        }
    };

    return { saveContactMessage };
}
